import axios from "axios";

const API_BASE_URL = getApiBaseUrl();

import { Transaction } from "../../domain/types/Transaction";
import { getApiBaseUrl } from "../../config/api";
import { RecurringTransaction } from "../../domain/types/RecurringTransaction";

export interface TransactionsSummary {
  period: string;
  income: {
    total: number;
    growth: number;
  };
  expenses: {
    total: number;
    growth: number;
  };
  net_summary: {
    net_amount: number;
    net_amount_growth: number;
  };
}

export const fetchTransactionsSummaryAPI = async (
  period: string,
  accessToken: string,
): Promise<TransactionsSummary> => {
  try {
    const response = await axios.get<TransactionsSummary>(
      `${API_BASE_URL}/api/v1/transactions/summary?period=${period}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching financial data:", error);
    throw error;
  }
};

export interface IncomeStatementSummary {
  [key: string]: {
    income: number;
    expenses: number;
  };
}

export async function fetchIncomeStatementSummaryAPI(
  period: string,
  accessToken: string,
): Promise<IncomeStatementSummary> {
  try {
    const response = await axios.get<IncomeStatementSummary>(
      `${API_BASE_URL}/api/v1/transactions/income_statement_for_period?period=${period}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    console.log("fetchIncomeStatementSummaryAPI response: ", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions summary:", error);
    throw error;
  }
}

export interface ExpensesByCategoryForPeriod {
  category: string;
  amount: number;
}

export async function fetchExpensesByCategoryForPeriodAPI(
  period: string,
  accessToken: string,
): Promise<ExpensesByCategoryForPeriod[]> {
  try {
    const response = await axios.get<ExpensesByCategoryForPeriod[]>(
      `${API_BASE_URL}/api/v1/transactions/expenses_by_category_for_period?period=${period}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    console.log(
      "fetchExpensesByCategoryForPeriodAPI response: ",
      response.data,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching expenses by category:", error);
    throw error;
  }
}

export interface FetchTransactionsAPIResult {
  transactions: Transaction[];
  next_cursor?: string;
  total_items?: number;
}

export async function fetchTransactionsAPI(
  accessToken: string,
  params: {
    account_ids: { [appUserId: string]: string[] };
    transaction_type: string;
    limit: number | null;
    cursor: string | null;
    sort_by: string;
    sort_order: string;
  },
): Promise<FetchTransactionsAPIResult> {
  try {
    const response = await axios.post<FetchTransactionsAPIResult>(
      `${API_BASE_URL}/api/v1/transactions`,
      {
        account_ids: params.account_ids,
        transaction_type: params.transaction_type,
        limit: params.limit,
        cursor: params.cursor,
        sort_by: params.sort_by,
        sort_order: params.sort_order,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching transactions from API:", error);
    throw error;
  }
}

export const fetchRecurringTransactionsAPI = async (
  accessToken: string,
): Promise<RecurringTransaction[]> => {
  try {
    const response = await axios.post<RecurringTransaction[]>(
      `${API_BASE_URL}/api/v1/transactions/recurring`,
      null,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching recurring transactions:", error);
    throw error;
  }
};
